define('presentation/common/routeToModal/presentationObjects/userPresentationObject',[],function() {
    return function(){
        var self = this;

        self.userId = null;
        self.firstName = null;
        self.lastName = null;
        self.full_name =  null;
        self.emailAddress = null;
        self.extension = null;
        self.avatar = null;
        self.hasAvatar = null;
        self.voicemailEnabled = null;
        self.createdDateTime = null;
        self.modifiedDateTime = null;
        self.displayText = null;
    };
});
